<div class="toast fade toast-width mt-2" [class]="type()" role="alert" aria-live="assertive" aria-atomic="true">
  <div class="toast-body">
    <div class="d-flex justify-content-between align-items-start">
      <strong>{{ title() }}</strong>
      <button type="button" class="btn-close" aria-label="Close" (click)="hide()"></button>
    </div>
    <div class="mt-2">{{ message() }}</div>
  </div>
</div>
